import React from 'react';
import update from 'immutability-helper';

function initialize(dialogs) {
  return {
    dialogs : Array.isArray(dialogs) ? dialogs : dialogs ? [dialogs] : [],
  };
}

function reducer(state, action) {
  switch (action.type) {
    case "OPEN": {
      if (state.selected) {
        //throw new Error(`dialog already mount : ${state.selected.name}`);
        // 他のダイアログが開かれている時は新しく開けないように設定
        return state;
      }

      const dialog = state.dialogs.find(dialog => dialog.name === action.name);
      if (!dialog) {
        throw new Error(`dialog not found : ${action.name}`);
      }
      return update(state, {
        selected: {$set: {
          name: dialog.name,
          component: dialog.component,
          fullScreen: dialog.fullScreen,
          dialogProps: {
            open: true,
            ...dialog.dialogProps,
            ...action.args,
            TransitionProps : { onExited: action.onExited },
            handleClose: action.handleClose
          }
        }}});
    }

    case "CLOSE": {
      if (state.selected.name !== action.name) {
        return state;
      }

      const closeState = { open: false }
      const newState = {};
      newState[action.name] = closeState;
      return update(state, {
        selected: {
          dialogProps: {
            open: {$set : false}
          }
        }
      });
    }

    case "ONEXITED": {
      if (state.selected.name !== action.name) {
        return state;
      }
      return update(state, {
        selected: {$set: undefined }
      });
    }
    default:
      return state;
  }
}

export default function useDialogs(dialogs) {
  const [state, dispatch] = React.useReducer(reducer, dialogs, initialize);

  const handleSelect = React.useCallback((target) => {
    if (!target) throw new Error("ダイアログの名称を渡してください。");
    const dialogName = (typeof target === "string") ? target : target.name;

    const handleClose = () => dispatch({ type: "CLOSE", name: dialogName });
    const onExited = () => dispatch({ type: "ONEXITED", name: dialogName });
    const handleOpen = (args) => dispatch({ type: "OPEN", name: dialogName, args, handleClose, onExited });

    return {
      close: handleClose,
      open: handleOpen,
    }
  }, [dispatch]);

  return [state.selected, handleSelect];
}